import { fetchJson, mutate } from './base-roros.service';

// ─── Types ──────────────────────────────────────────────────────────────────

export interface RorosLaunchpadStepStatus {
  step: string;
  completed: boolean;
  skipped?: boolean;
  data: Record<string, unknown>;
}

export interface RorosLaunchpadStatus {
  isComplete: boolean;
  is_complete?: boolean;
  current_step: string | null;
  steps: RorosLaunchpadStepStatus[];
}

export interface RorosTenantSettingsDTO {
  operating_mode: string | null;
  locale: string | null;
  timezone: string | null;
  currency: string | null;
  planning_cycle: string | null;
  ai_provider: string | null;
  ai_model: string | null;
  active_domains: Array<{ domain_id: number; name: string }>;
}

// ─── Launchpad ──────────────────────────────────────────────────────────────

// M18.2 (#21): field renamed planning_cycle → planningCycle to match backend schema
// J6: operatingMode + decisionNoteId added (GOV-03 — mode change requires Decision Note).
export interface UpdateRorosTenantSettingsPayload {
  planningCycle?: 'quarterly' | 'trimester';
  operatingMode?: 'founder' | 'growth' | 'scaling';
  /** REQUIRED when `operatingMode` is set — server enforces GOV-03. */
  decisionNoteId?: string;
}

export const RorosLaunchpadService = {
  getStatus: () => fetchJson<RorosLaunchpadStatus>('/api/v1/launchpad/status'),
  submitStep: (step: string, data: Record<string, unknown>) =>
    mutate(`/api/v1/launchpad/steps/${step}`, 'PUT', data),
  complete: () => mutate('/api/v1/launchpad/complete', 'POST'),
  getTenantSettings: () => fetchJson<RorosTenantSettingsDTO>('/api/v1/roros/tenant-settings'),
  updateTenantSettings: (payload: UpdateRorosTenantSettingsPayload) =>
    mutate('/api/v1/roros/tenant-settings', 'PATCH', payload),
};
